import { render, staticRenderFns } from "./chart2.vue?vue&type=template&id=dc5ba1ce&scoped=true"
import script from "./chart2.vue?vue&type=script&lang=js"
export * from "./chart2.vue?vue&type=script&lang=js"
import style0 from "./chart2.vue?vue&type=style&index=0&id=dc5ba1ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5ba1ce",
  null
  
)

export default component.exports